
export default {
  props: {
    icon: Array,
    label: String,
    size: String,
    content: Boolean,
  },

  computed: {
    _content: {
      set (value) {
        this.$emit('update:content', value)
        /*
        * TODO POSITION ACTION CLOSE is not good
        */
        this.$store.commit('notification/actionClose')
      },

      get () {
        return this.content
      }
    }
  },

  mounted () {
    // console.log(this.icon)
    if (this.content === undefined) this._content = false
  }
}
